import React from 'react';
import styled from 'styled-components';
import { Card, Typography, TypographyProps } from '@mui/material';
import { COLORS } from '../assets/colors';

interface NotFoundProps {
  title: string;
}

const NotFound: React.FC<NotFoundProps> = ({ title }) => (

  <CustomeCard variant='outlined'>
    <Title variant='body1'>{title}</Title>
  </CustomeCard>

);

export default NotFound;

const CustomeCard = styled(Card)`
height: 40px;
display: flex;
justify-content: center;
align-items: center;
margin-bottom:10px;
margin-top: 10px;
`;
// const Container = styled.div`
//   background-color: ${COLORS.pureWhite};
//   height: 40px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   border-radius: 4px;
//   border: 1px solid rgba(0, 0, 0, 0.12);
// `;

const Title = styled(Typography)`
  color: ${COLORS.mutedDark};
  font-size: 12px;
  font-weight: 800;
` as React.ComponentType<TypographyProps>;
